/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Create_AccountInputs */

const en_agent_authorization_create_account = /** @type {(inputs: Agent_Authorization_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a Seek AI account`)
};

const zh_agent_authorization_create_account = /** @type {(inputs: Agent_Authorization_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 Seek AI 账号`)
};

/**
* | output |
* | --- |
* | "Create a Seek AI account" |
*
* @param {Agent_Authorization_Create_AccountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_create_account = /** @type {((inputs?: Agent_Authorization_Create_AccountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Create_AccountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_create_account(inputs)
	return zh_agent_authorization_create_account(inputs)
});
export { agent_authorization_create_account as "agent.authorization.create_account" }